import { shallowRef, type ShallowRef } from "vue";

export type MarketsConfigurationSaveFn = () => Promise<void>;

export const marketsConfigurationSaveRef: ShallowRef<MarketsConfigurationSaveFn | null> =
  shallowRef(null);
